import React from 'react';
import '../../style/Footer.css';
import Tooltip from '../../assets/components/Tooltip';
import Help from '../../assets/icons/Help_Filled.svg';
import logoTitle from '../../assets/images/InteleradLogo.svg';

const Footer = ({ isLoginPage = false }) => {
    const date = new Date();
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    const PATENTS = "US Patents 6934698, 7457656, 7668835, 7958100, 8055636, and 8166381. System ID: 000011-01 +R127WR90/$\$79.5rspa–2022-build–4"

    return (
        <footer className="footer">
            <div className='footer__left'>
                <span style={{color: '#3D051A'}}>BY</span>
                <img src={logoTitle} className="footer__brand" />
                {!isLoginPage && <span>&copy; 2000-{new Date().getFullYear()}</span>}
            </div>
            {isLoginPage && 
                    <Tooltip text={`© 2024 Intelerad. All rights reserved.  Version: +1234567890/$$73.24.1.0D`} placement="top" arrow>
                        <span className='footer__patents'>© {new Date().getFullYear()} Intelerad. All rights reserved.  Version: v4.0.0.0</span>
                    </Tooltip>
                }
            <div className="footer__right">
                {isLoginPage && <a className='link'>Indications for Use</a>}
                <a className='link' target='_blank' href='https://www.intelerad.com/en/legal/terms-of-use/'>Terms of Use </a>
                <a className='link' target='_blank' href='https://www.intelerad.com/en/legal/privacy-policy/'>Privacy Policy</a>
            </div>
            {/* {!isLoginPage &&
                <Tooltip text={PATENTS} placement="top" arrow>
                    <span className="footer__patents">
                        {PATENTS}
                    </span>
                </Tooltip>} */}
            {/* {!isLoginPage && <div className="footer__right">
                <span className="footer__date">{formattedDate}</span>
                <img src={Help} alt="Help" className="footer__help-icon" />
            </div>} */}
        </footer>
    );
};

export default Footer;